import type { TradeDirection } from '@/components/TransactionModule/types';

import { buttons } from '@/styles/buttons';

import { InfoCircleSolidSmallIcon } from '@/ui/Icons/InfoCircleSolidSmallIcon';

import { useModuleContext } from '../ModuleContext';

/**
 * Opens the page-owned token panel for one side of the trade.
 *
 * Renders nothing unless the page supplied `onOpenTokenPanel`, and hides itself
 * at `desktop`, where that page shows the panel alongside the module.
 */
export const TokenInfoButton = ({ direction }: { direction: TradeDirection }) => {
  const { onOpenTokenPanel, sellToken, buyToken } = useModuleContext();
  const token = direction === 'buy' ? buyToken : sellToken;

  if (!onOpenTokenPanel || !token) return null;

  return (
    <button
      type="button"
      aria-label={`${token.symbol} details`}
      onClick={() => onOpenTokenPanel(direction)}
      className={buttons({
        size: 'small',
        color: 'transparent',
        shape: 'rounded',
        iconOnly: true,
        class: 'desktop:hidden size-8 p-0 text-token-gray-700',
      })}
    >
      <InfoCircleSolidSmallIcon aria-hidden />
    </button>
  );
};
